module.exports = __webpack_public_path__ + "static/media/INV-0287 - Administrative Penalty Order - Jasjit Sandhu.26f9e8ff.pdf";